export default "__VITE_ASSET__8rGHfrKO__"